import DlpRules from '@Policy/DataLossPrevention/PolicyTemplate/Filters/Dlp';

const DlpRulesGmail = () => {
  return (
    <DlpRules
      applyBoundShow={true}
      scanTargetShow={true}
      complianceRuleNoteShow={false}
      advancedOptionsShow={false}
      fileAdvancedOptionsShow={false}
      mipShow={false}
      showHeaderScan={true}
      showApprovedSenders={true}
    />
  );
};
export default DlpRulesGmail;
